import spaceoccupancyService from '@/api/spaceoccupancy'
import errorhandler from '@/utils/errorhandler.js'
import { SPACE_OCCUPANCY } from '../types'

export default {
  namespaced: true,
  state:{
    occupancyStatus: {}
  },
  getters: {
    occupancyStatus: (state) => {
      return state.occupancyStatus
    }
  },
  mutations: {
    [SPACE_OCCUPANCY.OCCUPANCY_STATUS](state, value){
      state.occupancyStatus = value
    }
  },
  actions: {
    async getOccupancyStatus({ commit }, payload){
      try{
        const response = await spaceoccupancyService.getOccupancyStatus(payload)
        commit(SPACE_OCCUPANCY.OCCUPANCY_STATUS, response.data)
      }catch(error){
        errorhandler.handleError(error)
      }
    }
  }
}
